import { Control } from "react-hook-form";
import { makeStyles } from "tss-react/mui";
import { MiControlledDatePicker, MiSection } from "@miplatform/components";
import { IInspectionAttempt } from "@miplatform/types";
import {
  mdiAccountOutline,
  mdiCalendarClock,
  mdiCalendarOutline,
} from "@mdi/js";
import { Box } from "@mui/system";
import { InspectionDetailsCard } from "../InspectionDetailsCard/InspectionDetailsCard";
import { InspectionSectionHeader } from "../InspectionSectionHeader";
import { IInspectionForm } from "../inspectionFormSchemas";

export const ScheduleDrawer = ({
  control,
  inspectionAttempt,
  title = "Schedule Inspection",
}: {
  control: Control<IInspectionForm>;
  inspectionAttempt: IInspectionAttempt;
  title?: string;
}) => {
  const { theme, classes } = useStyles();

  return (
    <Box>
      <MiSection
        headerTitle={title}
        headerIcon={mdiCalendarClock}
        headerIconColor={theme.palette.info.main}
      >
        <Box className={classes.formContainer}>
          <InspectionSectionHeader
            title="Schedule Date"
            icon={mdiCalendarOutline}
          />
          <Box className={classes.dateTimeInputContainer}>
            <Box className={classes.inputContainer}>
              <MiControlledDatePicker
                label="Date"
                name="scheduledDate"
                control={control}
                required
                whiteBackground
              />
            </Box>
          </Box>
        </Box>
        <Box>
          <InspectionSectionHeader title="Details" icon={mdiAccountOutline} />
          <InspectionDetailsCard inspectionAttempt={inspectionAttempt} />
        </Box>
      </MiSection>
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  formContainer: {
    display: "flex",
    flexDirection: "column",
  },
  dateTimeInputContainer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  inputContainer: {
    flex: 1,
  },
  addNotesButton: {
    textDecoration: "underline",
    textUnderlineOffset: theme.spacing(1.5),
  },
}));
